<div>
  <app-event-management-section-heading
    [id]="id"
    [title]="'event_form_details_title' | t"
    [description]="'event_form_details_description' | t"
  ></app-event-management-section-heading>

  <app-input-row
    [label]="'event_form_sports_and_disciplines' | t"
    [labelDescription]="'event_form_sports_and_disciplines_description' | t"
  >
    <app-multiselect
      [fc]="innerForm.controls.categories"
      [options]="categoryOptions"
      [emptyOption]="false"
    ></app-multiselect>
  </app-input-row>

  <ng-container *ngIf="this.innerForm.controls.categories.value.length > 0">
    <app-event-management-section-heading
      [title]="'event_form_distances' | t"
      [description]="'event_form_distances_description' | t"
    ></app-event-management-section-heading>

    <div class="sports-and-disciplines__multiselect-wrapper">
      <app-multi-select-advanced
        *ngFor="let sportId of this.innerForm.controls.categories.value"
        [title]="getSportTitleById(sportId)"
        (titleClick)="removeCategory(sportId)"
        [badgeColor]="COLOR_STYLES.DANGER"
        unspecifiedOptionTitle="{{ 'no_specific_distances_title' | t }}"
        customOptionTitle="{{ 'create_custom_distance' | t }}"
        (createCustomItem)="createCustomDistance()"
        [fc]="disciplinesForm.controls[sportId]?.controls.disciplines"
        [options]="getDistancesOption(sportId)"
      >
      </app-multi-select-advanced>
    </div>

    <app-event-management-section-heading
      [title]="'event_form_groups' | t"
      [description]="'event_form_groups_description' | t"
    ></app-event-management-section-heading>

    <div class="sports-and-disciplines__multiselect-wrapper">
      <app-multi-select-advanced
        *ngFor="let sportId of this.innerForm.controls.categories.value"
        [title]="getSportTitleById(sportId)"
        (titleClick)="removeCategory(sportId)"
        (createCustomItem)="createCustomGroup()"
        [badgeColor]="COLOR_STYLES.WARNING"
        unspecifiedOptionTitle="{{ 'no_specific_groups_title' | t }}"
        customOptionTitle="{{ 'create_custom_group' | t }}"
        [fc]="disciplinesForm.controls[sportId]?.controls.groups"
        [options]="getGroupsOptions(sportId)"
      >
      </app-multi-select-advanced>
    </div>
  </ng-container>
</div>
